import { combineReducers, configureStore } from "@reduxjs/toolkit";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from "redux-persist/lib/storage";
import filterReducer from '../features/filter/filterSlice';

const persistConfig = {
    key: "root",
    storage,
    whitelist: ["filter"], // List of reducers to persist
  };
const reducers = combineReducers({
   filter:filterReducer,
  });

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
   
   
    // Add any other middleware here
  });
export const persistor = persistStore(store);

export default store;
